import {
  Directive,
  ElementRef,
  HostListener,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Directive({
  selector: '[appCommaFormat]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommaFormatDirective),
      multi: true
    }
  ]
})
export class CommaFormatDirective implements ControlValueAccessor {

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    if (value !== null && value !== undefined && value !== '') {
      this.el.nativeElement.value = this.format(value.toString());
    } else {
      this.el.nativeElement.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {

    const cleanValue = value
      .replace(/,/g, '')        
      .replace(/[^0-9.]/g, ''); 

    if (cleanValue === '') {
      this.onChange('');
      this.el.nativeElement.value = '';
      return;
    }


    this.onChange(cleanValue);

    this.el.nativeElement.value = this.format(cleanValue);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  private format(value: string): string {
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
}
